"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxDomainPerApiKey = exports.maxSecretPerApiKey = exports.logMessageKeys = void 0;
exports.logMessageKeys = {
    startExecuteDriver: "driver.apiKey.log.startExecuteDriver",
    skipCreateApiKey: "driver.apiKey.log.skipCreateApiKey",
    apiKeyNotFound: "driver.apiKey.log.apiKeyNotFound",
    successCreateApiKey: "driver.apiKey.log.successCreateApiKey",
    failedExecuteDriver: "driver.apiKey.log.failedExecuteDriver",
};
exports.maxSecretPerApiKey = 2;
exports.maxDomainPerApiKey = 1;
//# sourceMappingURL=constants.js.map